import { ChakraV3, DividerWithContent, Spin } from '@piccolohealth/ui';
import React from 'react';
import { FaLock, FaSms } from 'react-icons/fa';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AuthCard } from './components/AuthCard';
import { AuthLayout } from './components/AuthLayout';
import { MFATypeButton } from './components/MFATypeButton';

export const MFAEnrol = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const auth = useAuth();
  const returnUrl = searchParams.get('return');

  const onEnrolTOTP = () => {
    const url = returnUrl
      ? `/mfa/totp-enrol?return=${encodeURIComponent(returnUrl)}`
      : '/mfa/totp-enrol';
    void navigate(url);
  };

  const onEnrolPhone = () => {
    const url = returnUrl
      ? `/mfa/phone-enrol?return=${encodeURIComponent(returnUrl)}`
      : '/mfa/phone-enrol';
    void navigate(url);
  };

  const onSkip = () => {
    void navigate(returnUrl ?? '/');
  };

  const onLogout = () => {
    auth.logout();
  };

  if (auth.isLoading) {
    return (
      <AuthLayout>
        <Spin />
      </AuthLayout>
    );
  }

  if (!auth.isAuthenticated || (!auth.showEnrolMfa && !returnUrl)) {
    return <Navigate to='/' />;
  }

  return (
    <AuthLayout>
      <AuthCard>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Text fontWeight='semibold' fontSize='2xl'>
            Set up 2-Step Verification
          </ChakraV3.Text>
          <ChakraV3.Text fontSize='sm' color='secondary'>
            Add an extra layer of security to your account by requiring a second verification step
            when you sign in.
          </ChakraV3.Text>
        </ChakraV3.Stack>
        <ChakraV3.Alert.Root status='warning' variant='surface' alignItems='center'>
          <ChakraV3.Alert.Indicator />
          <ChakraV3.Stack gap={1}>
            <ChakraV3.Text fontSize='lg' fontWeight='semibold'>
              Important
            </ChakraV3.Text>
            <ChakraV3.Text fontSize='sm'>
              We strongly recommend setting up 2-Step Verification to protect your account.
            </ChakraV3.Text>
          </ChakraV3.Stack>
        </ChakraV3.Alert.Root>
        <ChakraV3.Stack gap={4}>
          <MFATypeButton
            title='Authenticator app'
            description='Use an authenticator app to generate codes'
            icon={<FaLock />}
            onClick={onEnrolTOTP}
            badge={
              <ChakraV3.Tag colorPalette='green' fontSize='2xs'>
                Recommended
              </ChakraV3.Tag>
            }
          />
          <MFATypeButton
            title='SMS'
            description='Receive a code via phone text message'
            icon={<FaSms />}
            onClick={onEnrolPhone}
          />
          <DividerWithContent gap={4}>
            <ChakraV3.Text color='gray.400'>OR</ChakraV3.Text>
          </DividerWithContent>
          <ChakraV3.Button onClick={onSkip} size='md' variant='subtle'>
            Skip for now
          </ChakraV3.Button>
          <ChakraV3.Button onClick={onLogout} size='md' variant='subtle'>
            Logout
          </ChakraV3.Button>
        </ChakraV3.Stack>
      </AuthCard>
    </AuthLayout>
  );
};
